<template>
	<v-container grid-list-md>
		<h3>{{ $__("Edit Catalogue") }}</h3>
		<v-layout row wrap>
			<v-flex xs12>
				<CatalogueStepper :value="2"></CatalogueStepper>
			</v-flex>
			<v-flex xs12 md3>
				<v-card>
					<v-card-title primary-title style="padding: 6px 15px">
						{{ catalogue_categories.length }}
						{{ $t("Categories") }}
						<v-spacer></v-spacer>
						<v-btn @click="addCategory()">
							{{ $t("Add") }}
						</v-btn>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<draggable
							tag="v-list"
							@change="onSort"
							color="light-blue darken-4"
							:list="catalogue_categories"
							item-key="id"
							shaped
						>
							<v-list-item
								v-for="(item, i) in catalogue_categories"
								:key="i"
								@click="onCategoryClick(item)"
								:input-value="
									parseInt(item.category_id) ===
									parseInt($route().params.category_id)
								"
								active-class="grey lighten-2"
								dense
							>
								<v-list-item-icon>
									<v-icon class="handle">
										mdi-cursor-move
									</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title
										v-text="item.name"
									></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</draggable>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md9>
				<v-card>
					<v-tabs
						background-color="primary lighten-2"
						dark
						slider-color="secondary"
					>
						<v-tab>Added Products</v-tab>
						<v-tab>
							<v-badge
								color="secondary darken-1"
								:content="available_products.length"
								:value="available_products.length > 0"
							>
								{{ $t("Available Product") }}
							</v-badge>
						</v-tab>

						<v-tab-item>
							<template v-if="catalogue_products.length <= 0">
								<v-container
									grid-list-md
									fill-height
									class="text-center"
								>
									<v-avatar
										size="350"
										class="mx-auto mt-10"
										color="blue-grey lighten-5"
										dark
									>
										<v-layout row wrap>
											<v-flex xs12>
												<v-icon size="120"
													>mdi-database</v-icon
												>
											</v-flex>
											<v-flex xs12 class="px-10">
												<h1 class="pt-3">Empty</h1>
												<h4 class="pt-1 px-5">
													Please refresh or select
													category.
												</h4>
											</v-flex>
										</v-layout>
									</v-avatar>
								</v-container>
							</template>
							<template v-else>
								<draggable
									tag="v-list"
									@change="onProductSort"
									color="light-blue darken-4"
									:list="catalogue_products"
									item-key="id"
								>
									<v-list-item
										v-for="(
											catalogue_product, index
										) in catalogue_products"
										:key="'product_' + index"
										@click.native="
											$emit(
												'editProduct',
												catalogue_product
											)
										"
										:id="catalogue_product.id"
										style="border-bottom: 1px solid #e0e0e0"
										dense
									>
										<v-list-item-icon>
											<v-icon class="handle align-middle">
												mdi-cursor-move
											</v-icon>
										</v-list-item-icon>
										<v-list-item-action-text class="mr-3">
											<v-img
												:src="
													catalogue_product.image_url
												"
												max-width="80"
												width="80"
												height="60"
												aspect-ratio="4/3"
											></v-img>
										</v-list-item-action-text>
										<v-list-item-content>
											<v-list-item-title>
												{{
													catalogue_product.product_name
												}}
											</v-list-item-title>
											<v-list-item-subtitle>
												{{
													catalogue_product.formatted_price
												}}

												<template
													v-if="
														catalogue_product.subcategory_name
													"
												>
													|
													{{
														catalogue_product.subcategory_name
													}}
												</template>
											</v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<div
												class="
													d-flex
													justify-space-between
												"
											>
												<v-switch
													v-model="
														catalogue_product.active
													"
													dense
													@change="
														onProductActiveChanged(
															$event,
															catalogue_product.id
														)
													"
												></v-switch>

												<div
													class="grey lighten-5 ml-4"
												>
													<v-btn
														text
														@click="
															editProduct(
																catalogue_product
															)
														"
													>
														<span> Edit</span>
													</v-btn>

													<v-menu
														open-on-hover
														bottom
														offset-y
													>
														<template
															v-slot:activator="{
																on,
																attrs,
															}"
														>
															<v-btn
																icon
																text
																v-bind="attrs"
																v-on="on"
																style="
																	background-color: #f5f5f5;
																"
															>
																<v-icon>
																	mdi-menu-down
																</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item
																dense
																@click="
																	removeProduct(
																		catalogue_product
																	)
																"
															>
																<v-list-item-icon>
																	<v-icon>
																		mdi-delete
																	</v-icon>
																</v-list-item-icon>
																<v-list-item-content>
																	<v-list-item-title>
																		{{
																			$t(
																				"Remove"
																			)
																		}}
																	</v-list-item-title>
																</v-list-item-content>
															</v-list-item>
														</v-list>
													</v-menu>
												</div>
											</div>
										</v-list-item-action>
									</v-list-item>
								</draggable>
							</template>
						</v-tab-item>
						<v-tab-item>
							<v-list>
								<v-list-item
									v-for="(
										available_product, index
									) in available_products"
									:key="`available_product_` + index"
									style="border-bottom: 1px solid #e0e0e0"
									dense
								>
									<v-list-item-icon>
										<v-icon class="handle align-middle">
											mdi-cursor-move
										</v-icon>
									</v-list-item-icon>
									<v-list-item-action-text class="mr-3">
										<v-img
											:src="available_product.image_url"
											max-width="80"
											width="80"
											height="60"
											aspect-ratio="4/3"
										></v-img>
									</v-list-item-action-text>
									<v-list-item-content>
										<v-list-item-title>
											{{ available_product.name }}
										</v-list-item-title>
										<v-list-item-subtitle>
											{{
												available_product.formatted_price
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn
											text
											@click="
												addProduct(available_product)
											"
										>
											<v-icon left>mdi-plus</v-icon>
											{{ $t("Add to catalogue") }}
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
						</v-tab-item>
					</v-tabs>
				</v-card>
			</v-flex>
		</v-layout>

		<v-dialog v-model="productDialog" width="950">
			<ValidationObserver ref="productObs" v-slot="{ invalid }">
				<v-card>
					<v-card-title class="text-h5 grey lighten-2">
						{{
							product.product_name
								? "Edit Product"
								: "Add Product"
						}}
					</v-card-title>

					<v-card-text>
						<v-container grid-list-md>
							<v-layout row wrap>
								<v-flex xs12 md6>
									<app-image-uploader
										v-model="product.image_url"
									></app-image-uploader>
								</v-flex>
								<v-flex xs12 md6>
									<v-layout wrap row>
										<v-flex
											xs12
											md12
											v-if="product.product_name"
										>
											<ValidationProvider
												name="product_name"
												rules="required"
												v-slot="{ errors }"
											>
												<v-text-field
													label="Name"
													v-model="
														product.product_name
													"
													:error-messages="errors"
													readonly
												></v-text-field>
											</ValidationProvider>
										</v-flex>
										<v-flex xs12 md12>
											<ValidationProvider
												name="subcategory_id"
												rules=""
												v-slot="{ errors }"
											>
												<v-autocomplete
													:label="$t('Subcategory')"
													v-model="
														product.subcategory_id
													"
													:items="subcategories"
													item-value="id"
													item-text="name"
													:error-messages="errors"
												></v-autocomplete>
											</ValidationProvider>
										</v-flex>
										<v-flex xs12 md6>
											<ValidationProvider
												name="price"
												rules="required|min:0"
												v-slot="{ errors }"
											>
												<v-text-field
													label="Price"
													v-model="product.price"
													:error-messages="errors"
													type="number"
													step="0.01"
												></v-text-field>
											</ValidationProvider>
										</v-flex>
										<v-flex xs12 md6>
											<ValidationProvider
												name="sale_price"
												rules="min:0"
												v-slot="{ errors }"
											>
												<v-text-field
													label="Sale Price"
													v-model="product.sale_price"
													:error-messages="errors"
													type="number"
													step="0.01"
												></v-text-field>
											</ValidationProvider>
										</v-flex>

										<v-flex xs12 md12>
											<v-switch
												v-model="product.active"
												label="Is Active"
											></v-switch>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="error" text @click="closeProduct()">
							{{ $t("Close") }}
						</v-btn>
						<v-btn
							color="primary"
							:disabled="invalid"
							:loading="product.processing"
							@click.native="submitProduct()"
						>
							{{ $t("Submit") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</ValidationObserver>
		</v-dialog>

		<v-dialog v-model="categoryDialog" width="500" persistent>
			<ValidationObserver ref="categoryObs" v-slot="{ invalid }">
				<v-form>
					<v-card>
						<v-card-title class="grey lighten-2">
							{{ $t("Add Category") }}
						</v-card-title>

						<v-card-text>
							<v-container grid-list-md>
								<v-layout row wrap>
									<v-flex xs12>
										<ValidationProvider
											name="category_id"
											rules="required"
											v-slot="{ errors }"
										>
											<v-autocomplete
												:items="available_categories"
												item-value="id"
												item-text="name"
												label="Please select available category"
												v-model="category.category_id"
												:error-messages="errors"
											></v-autocomplete>
										</ValidationProvider>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>

						<v-divider></v-divider>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="error" text @click="closeCategory()">
								{{ $t("Close") }}
							</v-btn>
							<v-btn
								color="primary"
								:disabled="invalid"
								:loading="category.processing"
								@click.native="submitCategory()"
							>
								{{ $t("Submit") }}
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</ValidationObserver>
		</v-dialog>
	</v-container>
</template>

<script>
import CatalogueCategoriesComponent from "@Shop/components/CatalogueCategoriesComponent.vue";
import CatalogueProductsComponent from "@Shop/components/CatalogueProductsComponent.vue";
import draggable from "vuedraggable";
import VImageInput from "vuetify-image-input";
import CatalogueStepper from "@Shop/components/CatalogueStepper.vue";

export default {
	components: {
		CatalogueProductsComponent,
		CatalogueCategoriesComponent,
		draggable,
		VImageInput,
		CatalogueStepper,
	},

	props: [
		"catalogue",
		"outlets",
		"catalogue_categories",
		"available_categories",
		"catalogue_products",
		"available_products",
		"subcategories",
	],

	data() {
		return {
			panel: [],
			productDialog: false,
			product: this.$inertia.form({
				id: null,
				image: null,
				image_url: null,
				product_name: null,
				product_id: null,
				price: null,
				sale_price: null,
				active: null,
				sort_order: null,
				subcategory_id: null,
			}),
			stepper: this.$route().params.currentStep ?? 2,
			item: this.$inertia.form(this.catalogue),
			selectedCategory: null,
			categoryDialog: false,
			category: this.$inertia.form({
				category_id: null,
				catalogue_id: this.catalogue.id,
			}),
		};
	},

	methods: {
		submit() {
			this.item.put(
				this.$route("tenant.catalogues.update", {
					tenant: this.$page.props.tenant.id,
					catalogue: this.catalogue.uuid,
				})
			);
		},
		addCategory() {
			this.$inertia.reload({ only: ["available_categories"] });
			this.categoryDialog = true;
		},

		async onSort({ moved }) {
			try {
				await axios.post(
					this.$route("tenant.catalogue_categories.sort", {
						tenant: this.$page.props.tenant.id,
						id: moved.element.id,
						newIndex: moved.newIndex,
						oldIndex: moved.oldIndex,
					})
				);
				if (Object.keys(this.$page.props.errors).length <= 0) {
					this.$toast.open("Category has been sorted successfully");
					this.onCategoryClick();
				} else {
					this.$toast.error(
						"Something went wrong while sorting the category"
					);
				}
			} catch (e) {
				this.$toast.error(e.message);
			}
		},

		async onProductSort({ moved }) {
			try {
				await axios.post(
					this.$route("tenant.catalogue_products.sort", {
						tenant: this.$page.props.tenant.id,
						id: moved.element.id,
						newIndex: moved.newIndex,
						oldIndex: moved.oldIndex,
					})
				);
				if (Object.keys(this.$page.props.errors).length <= 0) {
					this.$toast.open("Product has been sorted successfully.");
				} else {
					this.$toast.error(
						"Something went wrong while sorting the product."
					);
				}
			} catch (e) {
				this.$toast.error(e.message);
			}
		},

		editProduct(product) {
			this.product = this.$inertia.form(
				Object.assign(
					{
						image: null,
					},
					product
				)
			);
			this.productDialog = true;
		},

		submitProduct() {
			this.product.put(
				this.$route("tenant.catalogue_products.update", {
					tenant: this.$page.props.tenant.id,
					id: this.product.id,
				}),
				{
					preserveState: (page) => true,
					preserveScroll: true,
					onSuccess: (page) =>
						Object.keys(page.props.errors).length <= 0
							? this.closeProduct()
							: null,
				}
			);
			this.stepper = 2;
		},

		closeProduct() {
			this.productDialog = false;
		},

		onCategoryClick(item) {
			this.$inertia.reload({
				only: [
					"catalogue_products",
					"available_products",
					"subcategories",
				],
				data: {
					category_id: item.category_id,
				},
			});
		},

		submitCategory() {
			this.category.post(
				this.$route("tenant.catalogue_cateogires.store", {
					tenant: this.$page.props.tenant.id,
					catalogue_id: this.catalogue.id,
					category_id: this.category_id,
				}),
				{
					preserveState: (page) =>
						page.props.flash.error ||
						Object.keys(page.props.errors).length > 0,
					preserveScroll: true,
				}
			);
			this.stepper = 2;
		},

		addProduct(product) {
			this.$inertia.post(
				this.$route("tenant.catalogue_products.store", {
					tenant: this.$page.props.tenant.id,
					catalogue_id: this.catalogue.id,
					category_id: this.$route().params.category_id,
					product_id: product.id,
				}),
				{
					preserveState: (page) =>
						page.props.flash.error ||
						Object.keys(page.props.errors).length > 0,
					preserveScroll: true,
				}
			);
		},

		removeProduct(product) {
			this.$inertia.delete(
				this.$route("tenant.catalogue_products.destroy", {
					tenant: this.$page.props.tenant.id,
					catalogue_id: this.catalogue.id,
					id: product.id,
				}),
				{
					preserveState: (page) => true,
					preserveScroll: true,
				}
			);
		},

		closeCategory() {
			this.categoryDialog = false;
		},

		removeCategory(id) {
			if (confirm("Are you sure want to delete this category?")) {
				this.$inertia.delete(
					this.$route("tenant.catalogue_cateogires.destroy", {
						tenant: this.$page.props.tenant.id,
						id: id,
					})
				);
			}
		},

		onProductActiveChanged(value, id) {
			this.$inertia.post(
				this.$route("tenant.catalogue_products.active", {
					tenant: this.$page.props.tenant.id,
					id: id,
					active: value,
				}),
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
	},
};
</script>